import React, { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import LigneImpotDetaille from "./LigneImpot";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import "./ContexteFiscal.css";

const CreditReduction = (props) => {
  const { Outil } = props;
  const context = useContext(AppContext);

  return (
    <div className="revenuspro-container">
      {/* Header principal */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">🎯</span>
          Crédits et réductions d'impôt
        </div>
        <div className="value-column">
          <span className="header-icon">💰</span>
          Montant
        </div>
      </div>

      {/* Section header: Réductions et crédits d'impôts divers */}
      <div className="header-card" style={{ marginTop: '16px', background: 'linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)' }}>
        <div className="category-column">
          <span className="header-icon">📊</span>
          Réductions et crédits d'impôts divers
        </div>
      </div>

      {/* Conteneur des cartes pour réductions diverses */}
      <div className="card-list-container">
        {/* Réductions et crédits d'impôts divers */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📊</div>
            Montant après abattements divers
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "ReductionImpot"]}
              onChange={context.handleInputChange(Outil + "ReductionImpot")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>

      {/* Section header: Dons et personne à domicile */}
      <div className="header-card" style={{ marginTop: '16px', background: 'linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)' }}>
        <div className="category-column">
          <span className="header-icon">❤️</span>
          Dons et personne à domicile
        </div>
      </div>

      {/* Conteneur des cartes pour dons */}
      <div className="card-list-container">
        {/* Dons à des organismes d'aide aux personnes en difficulté */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🤝</div>
            Dons à des organismes d'aide aux personnes en difficulté
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDonPersonne"]}
              onChange={context.handleInputChange(Outil + "IRDonPersonne")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Dons versés à des associations d'utilité publiques */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🏛️</div>
            Dons versés à des associations d'utilité publiques
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDonAssociation"]}
              onChange={context.handleInputChange(Outil + "IRDonAssociation")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Emploi d'une personne à domicile */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🏠</div>
            Emploi d'une personne à domicile
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IREmploiDomicile"]}
              onChange={context.handleInputChange(Outil + "IREmploiDomicile")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>

      {/* Section header: Frais de garde des enfants de moins de 6 ans */}
      <div className="header-card" style={{ marginTop: '16px', background: 'linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)' }}>
        <div className="category-column">
          <span className="header-icon">👶</span>
          Frais de garde des enfants de moins de 6 ans
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Enfants à charge exclusive
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Enfants à charge partagée
        </div>
      </div>

      {/* Conteneur des cartes pour frais de garde */}
      <div className="card-list-container">
        {/* 1er enfant */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👶</div>
            Premier enfant
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRFraisGardeEnfantExclusive1"]}
              onChange={context.handleInputChange(Outil + "IRFraisGardeEnfantExclusive1")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRFraisGardeEnfantPartagee1"]}
              onChange={context.handleInputChange(Outil + "IRFraisGardeEnfantPartagee1")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* 2ème enfant */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👶</div>
            Second enfant
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRFraisGardeEnfantExclusive2"]}
              onChange={context.handleInputChange(Outil + "IRFraisGardeEnfantExclusive2")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRFraisGardeEnfantPartagee2"]}
              onChange={context.handleInputChange(Outil + "IRFraisGardeEnfantPartagee2")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* 3ème enfant */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👶</div>
            Troisième enfant
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRFraisGardeEnfantExclusive3"]}
              onChange={context.handleInputChange(Outil + "IRFraisGardeEnfantExclusive3")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRFraisGardeEnfantPartagee3"]}
              onChange={context.handleInputChange(Outil + "IRFraisGardeEnfantPartagee3")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>

      {/* Section header: Enfants poursuivant des études */}
      <div className="header-card" style={{ marginTop: '16px', background: 'linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)' }}>
        <div className="category-column">
          <span className="header-icon">🎓</span>
          Nombre d'enfants poursuivant des études
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Enfants à charge exclusive
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Enfants à charge partagée
        </div>
      </div>

      {/* Conteneur des cartes pour études */}
      <div className="card-list-container">
        {/* Collège */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🏫</div>
            Collège
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IREtudeEnfantCollegeExclusive"]}
              onChange={context.handleInputChange(Outil + "IREtudeEnfantCollegeExclusive")}
              dataType="uint"
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IREtudeEnfantCollegePartagee"]}
              onChange={context.handleInputChange(Outil + "IREtudeEnfantCollegePartagee")}
              dataType="uint"
              normal
            />
          </div>
        </div>

        {/* Lycée */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🏫</div>
            Lycée
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IREtudeEnfantLyceeExclusive"]}
              onChange={context.handleInputChange(Outil + "IREtudeEnfantLyceeExclusive")}
              dataType="uint"
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IREtudeEnfantLyceePartagee"]}
              onChange={context.handleInputChange(Outil + "IREtudeEnfantLyceePartagee")}
              dataType="uint"
              normal
            />
          </div>
        </div>

        {/* Études supérieures */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🎓</div>
            Études supérieures
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IREtudeEnfantFacExclusive"]}
              onChange={context.handleInputChange(Outil + "IREtudeEnfantFacExclusive")}
              dataType="uint"
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IREtudeEnfantFacPartagee"]}
              onChange={context.handleInputChange(Outil + "IREtudeEnfantFacPartagee")}
              dataType="uint"
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditReduction;
